export interface ButtonTitles {
    new?: string;
    clear?: string;
    save?: string;
    cancel?: string;
}

export const DEFAULT_TITLES: ButtonTitles = {
    new: 'New',
    save: 'Save',
    clear: 'Clear',
    cancel: 'Cancel'
};
